import { render, staticRenderFns } from "./ResetPasswordConfirm.vue?vue&type=template&id=297a17c9&scoped=true&"
import script from "./ResetPasswordConfirm.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297a17c9",
  null
  
)

export default component.exports